import { render } from "./UserProfile.vue?vue&type=template&id=7c786f5f&scoped=true&ts=true"
import script from "./UserProfile.ts?vue&type=script&lang=ts"
export * from "./UserProfile.ts?vue&type=script&lang=ts"

import "./UserProfile.scss?vue&type=style&index=0&id=7c786f5f&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c786f5f"]])

export default __exports__